var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomOut02 = function SvgZoomOut02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M5.14 8.941h9.758v2.212H5.14Zm4.499-6.757a7.56 7.56 0 0 0-4.24 1.422C1.953 6.078 1.173 10.892 3.58 14.34c2.472 3.383 7.286 4.23 10.733 1.692 3.383-2.473 4.229-7.22 1.757-10.669a7.74 7.74 0 0 0-6.43-3.18M9.782 0a9.87 9.87 0 0 1 8.043 4.127c2.797 3.968 2.342 9.237-.911 12.555l10.279 12.88c.26.327.13.847-.195 1.042L25.37 31.84c-.39.26-.845.195-1.106-.13l-9.432-13.402c-4.36 2.602-10.018 1.431-13.011-2.732C-1.3 11.153-.324 5.038 4.099 1.85A9.73 9.73 0 0 1 9.782 0"
  }))));
};
export { SvgZoomOut02 as ReactComponent };
export default __webpack_public_path__ + "assets/Zoom Out_02.3de82cb01c203fc61fb33fb9fca4d6a4.svg";